<ng-container *ngIf="BarcodeData != undefined">
  <ng-container *ngIf="!RenderImage; else elseTemplate">
    <div class="barcode-container">
      <div class="canvas-container">
        <canvas id="canvas" width="1" height="1" style="display: none"></canvas>
      </div>
  
    </div>  
  </ng-container>
  <ng-template #elseTemplate>
    <div class="barcode-container">
      <div class="barcode-print-container">
        <canvas id="canvas" width="1" height="1" style="display: none"></canvas>
      </div>
  
    </div>  
    
  </ng-template>
  
</ng-container>